import { defineStore, acceptHMRUpdate } from 'pinia'
import { useCandidateStore } from '~/stores/candidate'
import { SseMessageType } from '~/types/SseMessage'
import type { SseEventMap } from '~/types/SseMessage'

export const useCandidateSseStore = defineStore('candidate-sse', () => {
  const candidateStore = useCandidateStore()
  const { candidate } = storeToRefs(candidateStore)

  const config = useRuntimeConfig()
  const serverUrl = config.public.serverUrl

  const sseUrl = computed(() => {
    if (!serverUrl) return undefined
    if (!candidate.value) return undefined
    return `${serverUrl}/sse/candidate/${candidate.value.id}`
  })

  function isKnownEventType(value: string): value is keyof SseEventMap {
    return Object.values(SseMessageType).includes(value as SseMessageType)
  }

  function handleData(data: string | null) {
    if (!data) return

    let parsedData: any

    try {
      parsedData = JSON.parse(data)
    } catch (e) {
      console.error('Error parsing data:', e)
      return
    }

    if (!parsedData.eventType) {
      console.warn('Tried to emit data, but no eventType was provided')
      return
    }

    if (!isKnownEventType(parsedData.eventType)) {
      console.warn(
        `[CandidateSse] Received unknown SSE event type: ${parsedData.eventType}`,
      )
      return
    }

    emitEvent(parsedData.eventType, parsedData)
  }

  const { status, error } = useSse(sseUrl, handleData)

  return { status, error }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useCandidateSseStore, import.meta.hot))
}
